import { baseApi } from './baseApi';

// "Novedades" — global changelog entries authored by support from the
// admin-panel. Tenants only ever see published entries.

export interface ChangelogEntryListItem {
  id: string;
  title: string;
  summary: string;
  publishedAt?: string;
}

export interface ChangelogEntryDetail extends ChangelogEntryListItem {
  htmlContent: string;
}

export const changelogApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getChangelogEntries: builder.query<ChangelogEntryListItem[], void>({
      query: () => '/changelog',
      providesTags: ['Changelog'],
    }),

    getChangelogEntry: builder.query<ChangelogEntryDetail, string>({
      query: (id) => `/changelog/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'Changelog' as const, id }],
    }),

    // Published entries newer than the user's last visit — drives the
    // "Nuevo" badge in the sidebar. Per user, stored in the global db.
    getChangelogUnseenCount: builder.query<{ count: number }, void>({
      query: () => '/changelog/unseen-count',
      providesTags: ['ChangelogUnseen'],
    }),

    markChangelogSeen: builder.mutation<void, void>({
      query: () => ({
        url: '/changelog/seen',
        method: 'POST',
      }),
      invalidatesTags: ['ChangelogUnseen'],
    }),
  }),
});

export const {
  useGetChangelogEntriesQuery,
  useGetChangelogEntryQuery,
  useGetChangelogUnseenCountQuery,
  useMarkChangelogSeenMutation,
} = changelogApi;
